import { getTokenHeader } from "@/helpers/commonHelper";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";

export default {
  async getServicePackages({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.booking_api_client_url}servicePackages`,
        {
          params: {
            principal_id: state.selectedPrincipal.id,
            ...filter
          },
          headers
        }
      );
      commit("SET_SERVICE_PACKAGE_COUNT", response.data.count ?? 0);
      commit("SET_SERVICE_PACKAGES", response.data.data ?? []);
    } catch (e) {
      await this.dispatch("createError", e);
      return false;
    }
  },
  async getAccommodationTypes({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.booking_api_client_url}accommodationTypes/`,
        {
          params: {
            principal_id: state.selectedPrincipal.id,
            ...filter
          },
          headers
        }
      );
      commit("SET_ACCOMMODATION_TYPE_COUNT", response.data.count ?? 0);
      commit("SET_ACCOMMODATION_TYPES", response.data.data ?? []);
    } catch (e) {
      await this.dispatch("createError", e);
      return false;
    }
  },
  async getBookingFeatures({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.booking_api_client_url}featureGroup/`,
        {
          params: {
            principal_id: state.selectedPrincipal.id,
            ...filter
          },
          headers
        }
      );
      commit("SET_BOOKING_FEATURE_GROUPS", response.data);
    } catch (e) {
      this.dispatch("createError", e);
      return false;
    }
  }
};
